import { useEffect, useRef } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { imgUrl } from '@/shared/utils';
import Link from 'next/link';

const Index = ({ data }: { data: any }) => {
  const { t } = useTranslation('common');
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;

    const scrollStep = 1;
    const scrollInterval = 30;

    const scroll = () => {
      container.scrollLeft += scrollStep;
      if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
        container.scrollLeft = 0;
      }
    };

    const intervalId = setInterval(scroll, scrollInterval);

    // 清理定时器
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {});
  return (
    <>
      <div className={styles.header}>
        <h2>{t('Recommended Article')}</h2>
        <span>
          <Link href={`${process.env.NEXT_APP_WEB_HOST}/blog`}>{'MORE >'}</Link>
        </span>
      </div>
      <div className={styles.main} ref={containerRef}>
        {data?.blogList?.map((item: any, index: number) => (
          <div key={index} className={styles.mainItem}>
            <Link href={`${process.env.NEXT_APP_WEB_HOST}/blog/${item.title_id}`} target="_blank">
              <div className={styles.head}>
                <Image
                  src={imgUrl(item.cover_image, 'mid')}
                  alt={item.title}
                  width={319}
                  height={469}
                  layout="responsive"
                />
              </div>
              <div className={styles.desc}>
                <h3>{t(item.title)}</h3>
                <p>{item.date}</p>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default Index;
